// AddressLocationPicker.jsx
import React, { useState } from "react";
import { MapPin, Locate } from "lucide-react";
import MapPicker from "./MapPicker";

const AddressLocationPicker = ({ className = "", showHeader = true, onLocationSelect }) => {
  // State for form data
  const [formData, setFormData] = useState({
    latitude: null,
    longitude: null,
    location: "",
  });
  const [isProcessingLocation, setIsProcessingLocation] = useState(false);

  // When a location is selected on the map
  const handleLocationSelect = (locationData) => {
    console.log("Selected location:", locationData);
    const address = locationData.address || locationData.location || '';
    const streetName = address.split(',')[0].trim();
    
    const newLocation = {
      latitude: locationData.latitude,
      longitude: locationData.longitude,
      location: address,
      streetName: streetName,
      address: address
    };
    
    setFormData(newLocation);
    
    // Pass location data to parent component
    if (onLocationSelect) {
      onLocationSelect(newLocation);
    }
  };

  // Use browser geolocation
  const handleGetCurrentLocation = () => {
    if (!navigator.geolocation) return alert("Geolocation not supported");
    setIsProcessingLocation(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        console.log("Current location:", latitude, longitude); // ✅ Log to console
        handleLocationSelect({
          latitude,
          longitude,
          location: `Lat: ${latitude.toFixed(6)}, Lng: ${longitude.toFixed(6)}`,
        });
        setIsProcessingLocation(false);
      },
      (err) => {
        console.error("Geolocation error:", err);
        setIsProcessingLocation(false);
        alert("Could not get current location");
      }
    );
  };

  return (
    <div className={`space-y-4 ${className}`}>
      {showHeader && (
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4">
          <div>
            <h3 className="font-medium text-gray-900">Delivery Location</h3>
            <p className="text-sm text-gray-500">
              Select your delivery address on the map or search for a location
            </p>
          </div>
          <button
            type="button"
            onClick={handleGetCurrentLocation}
            className="flex items-center justify-center gap-2 px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm w-full sm:w-auto"
            disabled={isProcessingLocation}
          >
            <Locate size={16} />
            {isProcessingLocation ? "Locating..." : "Use Current Location"}
          </button>
        </div>
      )}

      {/* MapPicker */}
      <div className="relative">
        <MapPicker
          onLocationSelect={handleLocationSelect}
          initialLocation={{
            lat: formData.latitude || 25.276987,
            lng: formData.longitude || 55.296249,
            address: formData.location || "",
          }}
          placeholder="Search for your address or click on the map..."
          className="mb-4"
        />
      </div>

      {/* Display selected location */}
      {formData.latitude && formData.longitude ? (
        <div className="mt-2 p-3 bg-green-50 border border-green-200 rounded-lg">
          <p className="text-sm text-green-700">
            <MapPin size={14} className="inline mr-1" />
            Location selected: {formData.location}
          </p>
        </div>
      ) : (
        <div className="mt-2 p-3 bg-blue-50 border border-blue-200 rounded-lg">
          <p className="text-sm text-blue-700">
            <MapPin size={14} className="inline mr-1" />
            Click anywhere on the map above to select your delivery location
          </p>
        </div>
      )}
    </div>
  );
};

export default AddressLocationPicker;
